export const red = 'rgb(255, 99, 132)';
export const yellow = 'rgb(255, 205, 86)';
export const green = 'green'; 